import { useState, useRef, useEffect } from 'react';
import Config from '../../Config';
import CryptoJS from 'crypto-js';
 
export function AutoPay(props)
{     
    
    const AUTOPAU_URL = "https://pay.autopay.eu/payment";
    const AUTOPAY_SERVICE_ID = 61915;
    const AUTOPAY_SERVICE_KEY = '71e21e9e4f9520b1ce437a9d716868bf6ec7941db5babf85d1a40d3bbf809f15';
    const description = 'Kod tymczasowy '+props.data.tempCode;

    var time =  Date.now();    

    var orderId = 'ap_'+time+'_'+(time - props.data.tempCode); 
    //var orderId = 'blumedia_1732194482034_51c9e6f87ce2a2bdc6e2be26ee89e825';
    var hash = AUTOPAY_SERVICE_ID+'|'+orderId+'|'+props.amount+'|'+description+'|0|PLN|'+props.userData.email+'|'+AUTOPAY_SERVICE_KEY;

    hash = CryptoJS.SHA256(hash).toString();

    

    const doPayForm = (event) => {
      
        let sendData = ({
            email:props.userData.email,
            client:props.userData.client,
            amount: props.amount,
            order_id: orderId,
            hash: hash,

        })

        fetch(Config.url+'/rest,doPay',{
            method:'POST',
            body: JSON.stringify(sendData), 
            mode:'cors',
            headers: {
                'Content-Type': 'text/html',
                'X-API-KEY': props.apiKey
            }
        })
        .then(res => res.json() )
        .then(res => {
            
            if(res.status=='ok')
            {
                const submitForm = document.getElementById('form_platnosci_'+props.amount);
                submitForm.submit();
            }

        })
        .catch(err => {
            console.log("Err " + err);
        });

        return false;
    }
    
    
    return (
            <div>
                <form method="POST" id={'form_platnosci_'+props.amount} action={AUTOPAU_URL} enctype="application/x-www-form-urlencoded">
                    <input type="hidden" id="id_ServiceID" name="ServiceID" value={AUTOPAY_SERVICE_ID} />
                    <input type="hidden" id="id_OrderID" name="OrderID" value={orderId} />
                    <input type="hidden" id="id_Amount" name="Amount" value={props.amount} />
                    <input type="hidden" id="id_Description" name="Description" value={description} />
                    <input type="hidden" id="id_GatewayID" name="GatewayID" value="0" />
                    <input type="hidden" id="id_GatewayID" name="Currency" value="PLN" />
                    <input type="hidden" id="id_CustomerEmail" name="CustomerEmail" value={props.userData.email} />  
                    <input type="hidden" id="hash" name="Hash" value={hash} />
                    <input type="button" onClick={doPayForm}  className="mw-button mw-button--lg mw-button--full" value={props.amount+' zł'} />
                </form>
            </div>
    )
   
}
